import type { OfferVM } from "./types";

export function isPromoActive(offer: OfferVM, now: Date = new Date()): boolean {
  if (offer.discountPercent == null || offer.discountPercent <= 0) return false;
  if (offer.discountExpiresAt == null) return true;
  return new Date(offer.discountExpiresAt).getTime() >= now.getTime();
}

export function effectivePrice(offer: OfferVM, now: Date = new Date()): number {
  if (!isPromoActive(offer, now)) return offer.priceUsd;
  return offer.priceUsd * (1 - (offer.discountPercent as number) / 100);
}

export function totalCost(offer: OfferVM, now: Date = new Date()): number {
  return effectivePrice(offer, now) + offer.activationFeeUsd;
}
